export enum DebateActionTypes {
    API_RESPONSE_SUCCESS = '@@rebate/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@rebate/API_RESPONSE_ERROR',
    REBATE_RECEVIED = '@@rebate/REBATE_RECEVIED',
    UPDREBATE_RECEVIED = '@@rebate/UPDREBATE_RECEVIED',
    UPD_REBATE_PAID = '@@rebate/UPD_REBATE_PAID',
    REBATE_PAID = '@@rebate/REBATE_PAID',
    RESET = '@@rebate/RESET',
}